if (!customElements.get('variant-stock-status')) {
    customElements.define(
        'variant-stock-status',
        class VariantStockStatus extends HTMLElement {
            constructor() {
                super();
                this.variantChangeUnsubscriber = undefined;
                this.stockStatusContainer = null;
                this.sectionId = null;
                this.variantMetafields = {};
            }

            connectedCallback() {
                this.sectionId = this.dataset.sectionId;
                this.stockStatusContainer = document.querySelector(`#stock-status-${this.sectionId}`);

                if (!this.stockStatusContainer) {
                    return;
                }

                // Subscribe to variant change events
                this.variantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    this.handleVariantChange.bind(this)
                );

                // Load variant metafields from page data
                this.loadVariantMetafields();

                // Initialize with current variant on page load
                this.initializeStockStatus();
            }

            loadVariantMetafields() {
                const metafieldsElement = document.querySelector(`variant-selects[data-section="${this.sectionId}"] [data-variant-metafields]`);

                if (metafieldsElement) {
                    try {
                        console.log('[Stock Status] Raw metafields JSON (first 500 chars):', metafieldsElement.innerHTML.substring(0, 500));
                        this.variantMetafields = JSON.parse(metafieldsElement.innerHTML);
                        console.log('[Stock Status] Parsed variant metafields:', this.variantMetafields);
                    } catch (error) {
                        console.error('Error parsing variant metafields:', error);
                        console.error('Raw content:', metafieldsElement.innerHTML);
                    }
                }
            }

            disconnectedCallback() {
                if (this.variantChangeUnsubscriber) {
                    this.variantChangeUnsubscriber();
                }
            }

            initializeStockStatus() {
                const variantSelectsElement = document.querySelector(
                    `variant-selects[data-section="${this.sectionId}"] [data-selected-variant]`
                );

                if (variantSelectsElement) {
                    try {
                        const variant = JSON.parse(variantSelectsElement.innerHTML);
                        this.updateStockStatus(variant);
                    } catch (error) {
                        console.error('Error parsing initial variant data:', error);
                    }
                }
            }

            handleVariantChange(event) {
                const { data } = event;

                // Check if this event is for our section
                if (data.sectionId !== this.sectionId) {
                    return;
                }

                // Get variant from event data or from updated HTML
                let variant = data.variant;

                if (!variant && data.html) {
                    // Try to extract variant from updated HTML
                    const variantSelectsElement = data.html.querySelector('variant-selects [data-selected-variant]');
                    if (variantSelectsElement) {
                        try {
                            variant = JSON.parse(variantSelectsElement.innerHTML);
                        } catch (error) {
                            console.error('Error parsing variant from HTML:', error);
                        }
                    }
                }

                if (variant) {
                    this.updateStockStatus(variant);
                }
            }

            updateStockStatus(variant) {
                if (!this.stockStatusContainer) return;

                console.log('[Stock Status] variant:', variant);
                console.log('[Stock Status] variant.metafields:', variant.metafields);
                console.log('[Stock Status] variant.id:', variant.id);
                console.log('[Stock Status] cached metafields:', this.variantMetafields);

                let instockValue = null;

                // Try to get instock from variant metafield
                if (variant && variant.metafields && variant.metafields.custom) {
                    instockValue = variant.metafields.custom.instock;
                    console.log('[Stock Status] instock from variant.metafields.custom.instock:', instockValue);
                } else if (variant && variant.id && this.variantMetafields[variant.id]) {
                    // Fallback: try to get metafields from cached data
                    const cachedData = this.variantMetafields[variant.id];
                    console.log('[Stock Status] cached data for variant:', cachedData);
                    if (cachedData) {
                        instockValue = cachedData.instock;
                        console.log('[Stock Status] instock from cache:', instockValue);
                    }
                } else {
                    console.log('[Stock Status] No metafields found - using fallback');
                }

                console.log('[Stock Status] Final instockValue:', instockValue);
                console.log('[Stock Status] isInStock will be:', instockValue === 'instock' || instockValue === 'new');

                // Determine stock status. Проданный вариант (остаток 0) — «Sold out»,
                // что бы ни стояло в custom.instock: изделие снимают остатком
                const isSoldOut = variant && variant.available === false;
                const isInStock = !isSoldOut && (instockValue === 'instock' || instockValue === 'new');
                const stockMessage = isSoldOut
                    ? ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out')
                    : isInStock
                        ? 'In Stock'
                        : 'Pre-order, production time 12-14 weeks';

                // Generate icons
                const iconInStock = `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2"/>
                        <path d="M5 8L7 10L11 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;
                const iconPreorder = `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2"/>
                        <path d="M8 4V9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <circle cx="8" cy="11.5" r="0.5" fill="currentColor"/>
                    </svg>
                `;

                // Update HTML
                const statusClass = isSoldOut
                    ? 'stock-status--sold-out'
                    : isInStock ? 'stock-status--in-stock' : 'stock-status--preorder';
                const icon = isInStock ? iconInStock : iconPreorder;

                this.stockStatusContainer.innerHTML = `
                    <p class="stock-status-message ${statusClass}">
                        <span class="stock-status-icon">${icon}</span>
                        <span class="stock-status-text">${stockMessage}</span>
                    </p>
                `;

                // Add animation
                this.animateStatusUpdate();
            }

            animateStatusUpdate() {
                // Add fade-in animation
                this.stockStatusContainer.style.opacity = '0';
                this.stockStatusContainer.style.transition = 'opacity 0.2s ease-out';

                setTimeout(() => {
                    this.stockStatusContainer.style.opacity = '1';
                    this.stockStatusContainer.style.transition = 'opacity 0.3s ease-in';
                }, 50);
            }
        }
    );
}
